export default __webpack_public_path__ + "static/media/product.38e72b0a.svg";